import { QueryClient } from 'react-query';
import {
  IClickToCallConfigurations,
  IClickToCallConfigurationsCMS,
  IGetClickToCallData,
} from './clicktocall.models';
import { openPopup, volaModalManager } from '@vfit/shared/data-access';
import { IClickToCallMeData } from '@vfit/shared/models';
import { removeCurrency } from '@vfit/shared/hooks';
import {
  isURL,
  getClickToCallUrl,
  getCtcSunriseTemplate,
  getProductCategory,
} from './clicktocall.utils';

const getClickToCall = (queryClient: QueryClient, clickToCallData?: IGetClickToCallData) => {
  const {
    idClickToCall,
    clickToCallFallbackUrl,
    clickToCallFallbackType,
    clickToCallFallbackTemplate,
    clickToCallOverrideConfiguration,
    product,
    taggingSunriseCtc,
    handleCloseForCtcIframe,
    handleCloseForCtcSunrise,
  } = clickToCallData || {};

  const cmsCommonApiKey =
    getProductCategory(product?.offerType) === 'fixed'
      ? 'getClickToCallFixedLineConfigurations'
      : 'getClickToCallMobileLineConfigurations';

  const cmsCommonApi = queryClient?.getQueryData?.(
    cmsCommonApiKey
  ) as IClickToCallConfigurationsCMS;
  const volaClickToCallData = queryClient?.getQueryData(
    'getClickToCallConfigurations'
  ) as IClickToCallMeData;

  const findConfiguration = (configurations: any[], key: string) =>
    configurations.find((ctcConf) => ctcConf?.key?.toLowerCase() === key?.toLowerCase());

  const productConfiguration = findConfiguration(
    product?.clicktocallconfigura?.elements || [],
    idClickToCall
  );
  const commonConfiguration = findConfiguration(
    cmsCommonApi?.clicktocallconfigura?.elements || [],
    idClickToCall
  );

  const configuration: IClickToCallConfigurations = clickToCallOverrideConfiguration ||
    productConfiguration ||
    commonConfiguration || {
      url: clickToCallFallbackUrl,
      type: clickToCallFallbackType || 'CTC_IFRAME',
      template: clickToCallFallbackTemplate,
    };

  if (configuration?.type) {
    switch (configuration.type) {
      case 'CTC_IFRAME':
        openPopup(getClickToCallUrl(configuration), handleCloseForCtcIframe);
        break;
      case 'CTC_SUNRISE':
        const templateData = getCtcSunriseTemplate(configuration?.template, queryClient);
        volaModalManager.handleVolaModal({
          url: getClickToCallUrl(configuration),
          cmsClickToCallData: configuration?.template
            ? { ...templateData }
            : { ...volaClickToCallData },
          ...(taggingSunriseCtc && { taggingOption: taggingSunriseCtc }),
          onClose: handleCloseForCtcSunrise,
          ...(product && {
            pageProduct: {
              product_name: product?.slug || '',
              product_price: product?.price ? removeCurrency(product?.price) : '',
              product_id: product?.offerId || '',
              product_quantity: '1',
              product_category: [getProductCategory(product?.offerType)],
            },
          }),
        });
        break;
      default:
        openPopup(getClickToCallUrl(configuration), handleCloseForCtcIframe);
        break;
    }
  }
};

const getClickToCallWithKeyOrUrl = (
  queryClient: QueryClient,
  keyOrUrl: string,
  product?,
  handleClose?: () => void
) => {
  if (isURL(keyOrUrl)) {
    return getClickToCall(queryClient, {
      clickToCallFallbackUrl: keyOrUrl,
      clickToCallFallbackType: 'CTC_IFRAME',
      handleCloseForCtcIframe: handleClose,
      product,
    });
  } else {
    return getClickToCall(queryClient, {
      idClickToCall: keyOrUrl,
      product,
      handleCloseForCtcSunrise: handleClose,
    });
  }
};

export { getClickToCall, getClickToCallWithKeyOrUrl };

